import { render } from "./image_slider.vue?vue&type=template&id=04c37fe6"
import script from "./image_slider.vue?vue&type=script&lang=js"
export * from "./image_slider.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/image_slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04c37fe6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04c37fe6', __exports__)) {
    api.reload('04c37fe6', __exports__)
  }
  
  module.hot.accept("./image_slider.vue?vue&type=template&id=04c37fe6", () => {
    api.rerender('04c37fe6', render)
  })

}


export default __exports__